// utils/createFieldByType.js
export async function createFieldByType(type, fallback) {
  try {
    const module = await import(`../controls/${type}.js`);

    const fnName =
      "create" + type.charAt(0).toUpperCase() + type.slice(1) + "Field";
    if (typeof module[fnName] === "function") {
      const field = module[fnName]();
      field.id = `${type}_${Date.now()}`;
      return field;
    }
    console.warn(`⚠️ ${fnName} introuvable, fallback utilisé.`);
  } catch (err) {
    alert(
      `❌ Impossible de charger le module "../controls/${type}.js".\n` +
      "Vérifie que le fichier existe et qu’il exporte la bonne factory."
    );
  }

  return (
    fallback?.() || {
      id: Date.now().toString(),
      type,
      title: `Champ ${type}`,
      name: type.toLowerCase(),
    }
  );
}